<template>
    <section class="main">
        <HeadSectionMain :data="head" class="fill-height"/>
        <OurProducts style="background: white"/>
        <template v-for="(product, i) in listProducts" :key="i">
            <productComponent :data="product"
                              class="track-reverse"
                              :src-img="'products/xTrack/'"
                              :class="[
                                  i%2 && 'color-gray' || 'reverse color-white',
                                  // i === 0 && 'first',
                                  // (i === listProducts.length - 1) && 'last'
                              ]"
            />
        </template>
        <infoComponent style="background: white; padding-bottom: 80px"/>
    </section>
</template>

<script>
export default {
    name: "xTrackPage",
    data() {
        return {
            jsonFile: ''
        }
    },
    computed: {
        head(){
            return this.jsonFile?.head
        },
        listProducts() {
            return this.jsonFile?.list_products
        }
    },
    created() {
        this.jsonFile = require('../../pages/xTrack.json');
    },
    mounted() {
    }
}
</script>
<style scoped lang="scss">
.color-white {
    background: white;
}
.color-gray {
    background: #FAFBFD;
}
</style>
<style lang="scss">

.main {
    .product-item {
        &.first,
        &.last {
            background: white;
        }
    }
    .product-item__flex {
        flex-direction: row;
    }
    .reverse {
        background: #F9F9F9;
        &.product-item {
            .product-item__flex {
                flex-direction: row-reverse;
            }
        }
    }
}
</style>